import { gql } from "@apollo/client";

export const COMPANIES = gql`
  query Companies($query: String!) {
    companies(query: $query) {
      siret
      siren
      legalName
      legalForm
      nafCode
      address {
        street
        zipCode
        city
      }
      headcountTier
      creationDate
      mainActivity
      idcc
    }
  }
`;

const companies = { COMPANIES };

export default companies;
